import ImageOptimizer from '@/components/image-optimizer';
import { convertToHyphen, extractTextOnly, slugify } from '@/lib/utils';
import { ArticleEntity } from '@/services/types/article.type';
import ReviewArrow from '@/svg/review_arrow.svg';

import Link from 'next/link';

export default function BlogCard({
  id,
  title,
  content,
  thumbPath,
  board,
}: ArticleEntity) {
  return (
    <Link
      href={
        '/' +
        convertToHyphen(board.type.replace('_training', '')) +
        '/' +
        slugify(title, id)
      }
      className="block transition"
    >
      <div className="border-stroke-white desktop:rounded-xl desktop:gap-15 desktop:px-12 desktop:py-9 flex w-full justify-between rounded-2xl border px-5 py-7">
        <div className="desktop:flex-row desktop:items-center flex w-full flex-col rounded-xl bg-white">
          <div className="desktop:flex-col flex flex-col">
            <div className="text-level-2 typo-22 desktop:typo-28 desktop:leading-snug desktop:mb-3 mb-4 flex justify-between gap-2 leading-[33px] font-extrabold">
              <span className="line-clamp-2">{title}</span>
              {/**모바일 썸네일 */}
              <div className="desktop:hidden relative aspect-[107/64] h-[64px]">
                <ImageOptimizer
                  src={thumbPath}
                  alt={title}
                  fill
                  className="overflow-hidden rounded-xl object-cover"
                />
              </div>
            </div>
            <div className="text-level-3 typo-16 desktop:typo-20 desktop:leading-relaxed desktop:min-h-[52px] line-clamp-2 leading-relaxed font-semibold">
              {extractTextOnly(content)}
            </div>
            <div className="text-main-blue typo-16 desktop:typo-18 desktop:mt-10 mt-5 flex items-center gap-1 font-bold">
              내용보기 <ReviewArrow />
            </div>
          </div>
        </div>
        {/**웹 썸네일 */}
        <div className="desktop:inline-block relative hidden aspect-[233/158] h-[158px]">
          <ImageOptimizer
            src={thumbPath}
            alt={title}
            fill
            className="overflow-hidden rounded-xl object-cover"
          />
        </div>
      </div>
    </Link>
  );
}
